$('.accordion').on('click', function (event) {
  event.preventDefault();
  $('.accordion').not(this).addClass('closed').each(function() {
    this.open = false;
  });
  $(this).toggleClass('closed');
  this.open = !this.open;
});
